/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Or_Without_AiInputs */

const en_register_onboarding_personal_info_or_without_ai = /** @type {(inputs: Register_Onboarding_Personal_Info_Or_Without_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or without AI extraction`)
};

const de_register_onboarding_personal_info_or_without_ai = /** @type {(inputs: Register_Onboarding_Personal_Info_Or_Without_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oder ohne KI-Extraktion`)
};

/**
* | output |
* | --- |
* | "Or without AI extraction" |
*
* @param {Register_Onboarding_Personal_Info_Or_Without_AiInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_or_without_ai = /** @type {((inputs?: Register_Onboarding_Personal_Info_Or_Without_AiInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Or_Without_AiInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_or_without_ai(inputs)
	return en_register_onboarding_personal_info_or_without_ai(inputs)
});